import { Toaster } from "@/components/ui/toaster"
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClientInstance } from '@/lib/query-client'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import PageNotFound from './lib/PageNotFound';
import { AuthProvider, useAuth } from '@/lib/AuthContext';
import UserNotRegisteredError from '@/components/UserNotRegisteredError';
import AnalyticsTracker from '@/components/AnalyticsTracker';
import { lazy, Suspense } from 'react';
import Welcome from './pages/Welcome';
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const InvoicePayment = lazy(() => import('./pages/InvoicePayment'));
const NonProfits = lazy(() => import('./pages/NonProfits'));
const EquineHostingProjects = lazy(() => import('./pages/EquineHostingProjects'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const Portfolio = lazy(() => import('./pages/Portfolio'));
const ThankYou = lazy(() => import('./pages/ThankYou'));
const AIApplications = lazy(() => import('./pages/AIApplications'));
import { Navigate } from 'react-router-dom';
import SiteLayout from '@/components/SiteLayout';
// Add page imports here

const AuthenticatedApp = () => {
  const { isLoadingAuth, isLoadingPublicSettings, authError, navigateToLogin } = useAuth();

  // Show loading spinner while checking app public settings or auth
  if (isLoadingPublicSettings || isLoadingAuth) {
    return (
      <div className="fixed inset-0 flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-slate-200 border-t-slate-800 rounded-full animate-spin"></div>
      </div>
    );
  }

  // Handle authentication errors
  if (authError) {
    if (authError.type === 'user_not_registered') {
      return <UserNotRegisteredError />;
    } else if (authError.type === 'auth_required') {
      // Redirect to login automatically
      navigateToLogin();
      return null;
    }
  }

  // Render the main app
  return (
    <Suspense fallback={null}>
    <Routes>
      <Route path="/" element={<Welcome />} />
      <Route path="/invoice-payment" element={<InvoicePayment />} />
      <Route element={<SiteLayout />}>
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/non-profits" element={<NonProfits />} />
        <Route path="/equine-hosting-projects" element={<EquineHostingProjects />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/ai-applications" element={<AIApplications />} />
      </Route>
      <Route path="/welcome" element={<Navigate to="/" replace />} />
      <Route path="/devries-co" element={<Navigate to="/portfolio" replace />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
    </Suspense>
  );
};


function App() {

  return (
    <AuthProvider>
      <QueryClientProvider client={queryClientInstance}>
        <Router>
          <AnalyticsTracker />
          <AuthenticatedApp />
        </Router>
        <Toaster />
      </QueryClientProvider>
    </AuthProvider>
  )
}

export default App